import PropTypes from 'prop-types'
import React from 'react'

const Conditional = ({ children, showIf }) => {
  if (showIf) {
    return <>{children}</>
  }
  return <div style={{ display: 'none' }}>{children}</div>
}

Conditional.propTypes = {
  children: PropTypes.node.isRequired,
  showIf: PropTypes.bool.isRequired,
}

export default Conditional
